import { Content, type ContentProps } from './Content';
import { Info, type InfoProps } from './Info';
import { Name, type NameProps } from './Name';
import { Root, type RootProps } from './Root';
import { TitleImage, type TitleImageProps } from './TitleImage';

export {
  Content,
  type ContentProps,
  Info,
  type InfoProps,
  Name,
  type NameProps,
  Root,
  type RootProps,
  TitleImage,
  type TitleImageProps,
};
